
  // --- API Variables ---
  const reviewSectionNew = document.querySelector('section[data-reviews-section]');

  const productId = reviewSectionNew.getAttribute('data-product-id');
  const productTitle = reviewSectionNew.getAttribute('data-product-title');
  const productSku = reviewSectionNew.getAttribute('data-product-sku');
  const productUrl = reviewSectionNew.getAttribute('data-product-url');
  const productImage = reviewSectionNew.getAttribute('data-product-image');
  const sId = 140577;
  const apiKey = 'pubkey-C1GDETra4tfolQMJB903HhN8QJ574k';
  const minRating = 1;
  const apiUrl = `https://api.monitors.com/api/v1/web/reviews?productId=${productId}&minRating=${minRating}`;
  const questionsApiUrl = `https://api.monitors.com/api/v1/web/questions?productId=${productId}&state=published`;
  const createQuestionAPI = `https://submit.monitors-com.workers.dev/submit-question`;

  // --- Helpers ---
  // ISO-3166-1 alpha-2 only — blocks Translate & Adapt values like "ee. uu." / "vs"
  const VALID_COUNTRY_ISOS = new Set([
    'ad','ae','af','ag','ai','al','am','ao','aq','ar','as','at','au','aw','ax','az',
    'ba','bb','bd','be','bf','bg','bh','bi','bj','bl','bm','bn','bo','bq','br','bs','bt','bv','bw','by','bz',
    'ca','cc','cd','cf','cg','ch','ci','ck','cl','cm','cn','co','cr','cu','cv','cw','cx','cy','cz',
    'de','dj','dk','dm','do','dz','ec','ee','eg','eh','er','es','et',
    'fi','fj','fk','fm','fo','fr','ga','gb','gd','ge','gf','gg','gh','gi','gl','gm','gn','gp','gq','gr','gs','gt','gu','gw','gy',
    'hk','hm','hn','hr','ht','hu','id','ie','il','im','in','io','iq','ir','is','it','je','jm','jo','jp',
    'ke','kg','kh','ki','km','kn','kp','kr','kw','ky','kz','la','lb','lc','li','lk','lr','ls','lt','lu','lv','ly',
    'ma','mc','md','me','mf','mg','mh','mk','ml','mm','mn','mo','mp','mq','mr','ms','mt','mu','mv','mw','mx','my','mz',
    'na','nc','ne','nf','ng','ni','nl','no','np','nr','nu','nz','om','pa','pe','pf','pg','ph','pk','pl','pm','pn','pr','ps','pt','pw','py','qa',
    're','ro','rs','ru','rw','sa','sb','sc','sd','se','sg','sh','si','sj','sk','sl','sm','sn','so','sr','ss','st','sv','sx','sy','sz',
    'tc','td','tf','tg','th','tj','tk','tl','tm','tn','to','tr','tt','tv','tw','tz','ua','ug','um','us','uy','uz',
    'va','vc','ve','vg','vi','vn','vu','wf','ws','ye','yt','za','zm','zw'
  ]);

  function normalizeCountryIso(iso) {
    if (!iso || typeof iso !== 'string') return 'us';
    const cleaned = iso
      .replace(/\u00a0/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .trim()
      .toLowerCase();
    if (/^[a-z]{2}$/.test(cleaned) && VALID_COUNTRY_ISOS.has(cleaned)) return cleaned;
    return 'us';
  }

  function getCountryFlag(iso, location) {
    iso = normalizeCountryIso(iso);

    // Add condition for United Arab Emirates
    if (location === 'United Arab Emirates') {
      iso = 'ae';
    }
    else if (location === 'Canada' || location === 'Canadá') {
      iso = 'ca';
    }
    return `https://cdn.shopify.com/static/images/flags/${iso}.svg`;
  }
  function getStars(rating) {
    let stars = '';
    for (let i = 0; i < 5; i++) {
      stars += `<svg width="14" height="14" class="inline" viewBox="0 0 14 14" fill="none"><path d="M8.63379 5.4917L8.73828 5.71143L8.97949 5.73682L12.7852 6.13721L9.8623 8.81885L9.67969 8.98584L9.73145 9.22803L10.5312 12.9917L7.10742 11.0591L6.89453 10.939L6.68066 11.0591L3.25684 12.9907L4.05762 9.22803L4.1084 8.98584L3.92578 8.81885L1.00195 6.13721L4.80957 5.73682L5.05078 5.71143L5.15527 5.4917L6.89355 1.84717L8.63379 5.4917Z" fill="${i < rating ? '#F8D62D' : '#9CA3AF'}" stroke="${i < rating ? '#F8D62D' : '#9CA3AF'}" stroke-width="0.866725"/></svg>`;
    }
    return stars;
  }

  // Render ratings summary dynamically
  function renderRatingSummary(ratingsCount, totalReviews, avgRating) {
    function renderStars(filled) {
      let stars = '';
      for (let i = 1; i <= 5; i++) {
        stars += `<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M8.63379 5.4917L8.73828 5.71143L8.97949 5.73682L12.7852 6.13721L9.8623 8.81885L9.67969 8.98584L9.73145 9.22803L10.5312 12.9917L7.10742 11.0591L6.89453 10.939L6.68066 11.0591L3.25684 12.9907L4.05762 9.22803L4.1084 8.98584L3.92578 8.81885L1.00195 6.13721L4.80957 5.73682L5.05078 5.71143L5.15527 5.4917L6.89355 1.84717L8.63379 5.4917Z" fill="${i <= filled ? '#F8D62D' : '#9CA3AF'}" stroke="${i <= filled ? '#F8D62D' : '#9CA3AF'}" stroke-width="0.866725"/></svg>`;
      }
      return stars;
    }

    const avgBarPercent = totalReviews ? (avgRating / 5) * 100 : 0;

    let rows = '';
    for (let i = 5; i >= 1; i--) {
      const count = ratingsCount[i - 1];
      let yellowPercent = 0;
      let grayPercent = 100;
      if (count > 0) {
        yellowPercent = (i / 5) * 100;
        grayPercent = 100 - yellowPercent;
      }
      rows += `
        <div class="flex items-center gap-2">
          <div class="flex gap-0.5">${renderStars(i)}</div>
          <div class="flex items-center justify-center rounded-xs overflow-hidden w-17.5 md:w-33 h-3.5">
            <span class="h-3.5 bg-yellow-300 block" style="width:${yellowPercent}%"></span>
            <span class="h-3.5 bg-gray-200 block" style="width:${grayPercent}%"></span>
          </div>
          <span class="text-gray-600 text-xs font-normal leading-normal">(${count})</span>
        </div>
      `;
    }

    let avgStars = '';
    for (let i = 1; i <= 5; i++) {
      avgStars += `<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M8.63379 5.4917L8.73828 5.71143L8.97949 5.73682L12.7852 6.13721L9.8623 8.81885L9.67969 8.98584L9.73145 9.22803L10.5312 12.9917L7.10742 11.0591L6.89453 10.939L6.68066 11.0591L3.25684 12.9907L4.05762 9.22803L4.1084 8.98584L3.92578 8.81885L1.00195 6.13721L4.80957 5.73682L5.05078 5.71143L5.15527 5.4917L6.89355 1.84717L8.63379 5.4917Z" fill="${i <= Math.round(avgRating) ? '#F8D62D' : '#9CA3AF'}" stroke="${i <= Math.round(avgRating) ? '#F8D62D' : '#9CA3AF'}" stroke-width="0.866725"/></svg>`;
    }

    return rows;
  }

  // handleReviewsUpVote function

  function handleReviewsUpVote(reviewId, el) {
    const upvoteContainer = el.closest('.reviews-upvote-container');
    if (!upvoteContainer) return;

    upvoteContainer.style.opacity = '0.5';

    fetch('https://stamped.io/api/reviews/vote', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        reviewId: reviewId,
        vote: 1,
        apiKey: apiKey,
        sId: sId
      })
    })
    .then(res => res.json())
    .then(data => {
      const upvoteSpan = upvoteContainer.querySelector('span.reviewsCountSpan');
      if (upvoteSpan && typeof data.voteUp === 'number') {
        upvoteSpan.textContent = data.voteUp;
      }
    })
    .catch(err => {
      console.error('Error submitting vote:', err);
    })
    .finally(() => {
      upvoteContainer.style.opacity = '1';
    });
  }

  // script to manage the toggle of share review links

  function toggleShareReviewLinks(btn) {
    const links = btn.parentElement.querySelector('.shareReviewLinks');
    if (!links) return;
    if (links.classList.contains('invisible')) {
      links.classList.remove('invisible', 'opacity-0');
      links.classList.add('visible', 'opacity-100');
    } else {
      links.classList.remove('visible', 'opacity-100');
      links.classList.add('invisible', 'opacity-0');
    }
  }

  // function to set review rating stars in add review forms

  function setReviewRating(starIndex, el) {
    const container = el.closest('.reviewRatingStarContainer');
    if (!container) return;
    const stars = container.querySelectorAll('svg');
    const input = container.querySelector('#reviewRating');
    stars.forEach((star, idx) => {
      const path = star.querySelector('path');
      if (path) {
        if (idx < starIndex) {
          path.setAttribute('fill', '#F8D62D');
          path.setAttribute('stroke', '#F8D62D');
        } else {
          path.setAttribute('fill', '#9CA3AF');
          path.setAttribute('stroke', '#9CA3AF');
        }
      }
    });
    if (input) input.value = starIndex;
  }

  function getFullCountryName(shopifyCode) {
    if (!shopifyCode) return 'United States';
    const match = countryPhoneCodes.find(c => c.shopifyCode === shopifyCode);
    return match ? match.country : 'United States';
  }

  function normalizeImageUrl(url) {
    if (url && url.startsWith('//')) {
      return 'https:' + url;
    }
    return url;
  }

  function getFacebookShareUrl(reviewId) {
    const appId = '941057476855139';
    const href = encodeURIComponent(`https://monitors.com/a/review/facebookpost?reviewId=${reviewId}`);
    const redirectUri = encodeURIComponent(`https://stamped.io/shares?review_id=${reviewId}`);
    return `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${href}&redirect_uri=${redirectUri}`;
  }

  function getTwitterShareUrl(reviewMessage, reviewId) {
    const text = encodeURIComponent(reviewMessage);
    const url = encodeURIComponent(`https://monitors.com/a/review/twittercard?reviewId=${reviewId}`);
    return `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  }

  // validation helper
  function validateNotEmpty(inputIds) {
    for (let i = 0; i < inputIds.length; i++) {
      const input = document.getElementById(inputIds[i]);
      if (!input) return false;
      const parentDiv = input.closest('div');
      if (!parentDiv) return false;
      if (!input.value.trim()) {
        parentDiv.classList.add('form-error');
        return false; // Stop at the first error
      } else {
        parentDiv.classList.remove('form-error');
      }
    }
    return true;
  }

  // remove error from inputs

  document.querySelectorAll('#reviewsCustomLoaded input, #reviewsCustomLoaded textarea').forEach(el => {
    el.addEventListener('input', function() {
      const parentDiv = this.closest('div');
      if (parentDiv && parentDiv.classList.contains('form-error')) {
        parentDiv.classList.remove('form-error');
      }
    });
  });

  // render reviews using metaobjects without relaying on API

  // --- Render Reviews from reviewMetaData ---
  function renderReviewsFromMetaData() {
    if (!window.reviewMetaData) {
      console.log('No review metadata available');
      return;
    }

    let reviews = window.reviewMetaData.reviews;

    // This product's own reviews always come first; same-model (collected-from)
    // reviews follow. Newest-to-oldest within each of those two groups.
    reviews = reviews.sort((a, b) => {
      if (a.isOwnReview !== b.isOwnReview) {
        return a.isOwnReview ? -1 : 1;
      }

      // Parse MM/DD/YYYY format
      const parseDate = (dateStr) => {
        const [month, day, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day); // month is 0-indexed in Date constructor
      };

      const dateA = parseDate(a.reviewDate);
      const dateB = parseDate(b.reviewDate);

      // Return negative value if dateB is older (for descending order)
      return dateB - dateA;
    });

    const totalReviews = window.reviewMetaData.totalReviews || 0;
    const container = document.getElementById('reviewsCardsContainer');

    // Calculate ratings count and average
    const ratingsCount = [0, 0, 0, 0, 0]; // [1-star, 2-star, 3-star, 4-star, 5-star]
    let ratingsSum = 0;
    reviews.forEach(r => {
      const rating = Math.round(r.reviewRating);
      if (rating >= 1 && rating <= 5) {
        ratingsCount[rating - 1]++;
        ratingsSum += rating;
      }
    });
    const avgRating = totalReviews ? (ratingsSum / totalReviews) : 0;

    // Update rating summary
    document.getElementById('ratingSummaryContainer').innerHTML = renderRatingSummary(ratingsCount, totalReviews, avgRating);

    // Update reviews tab count
    document.querySelector('#reviewsTabBtn span').textContent = `(${totalReviews})`;

    // Collect up to 6 review photos from reviewMetaData
    const reviewPhotos = [];
    reviews.forEach(r => {
      if (r.reviewUserPhotos && reviewPhotos.length < 6) {
        // If reviewUserPhotos is a comma-separated string, split and push each
        const photos = r.reviewUserPhotos.split(',');
        photos.forEach(photo => {
          if (photo && reviewPhotos.length < 6) {
            reviewPhotos.push(`https://cdn.stamped.io/tr:h-800:/uploads/photos/${photo.trim()}`);
          }
        });
      }
    });

    // Split into two arrays for column layout
    const reviewsCol1 = [];
    const reviewsCol2 = [];

    reviews.forEach((item, idx) => {
      if (idx % 2 === 0) {
        reviewsCol1.push(item);
      } else {
        reviewsCol2.push(item);
      }
    });
      
    // Responsive merge
    let _reviews;
    if (window.innerWidth >= 768) {
      _reviews = [...reviewsCol1, ...reviewsCol2];
    } else {
      _reviews = reviews;
    }

    if (!container) return;


    // Render reviews using reviewMetaData
    container.innerHTML = _reviews.map(review => {

      return `
      <div class="border-b border-0 md:border border-gray-200 md:rounded-lg px-4 py-3 flex flex-col gap-4 mb-3 md:mb-4 break-inside-avoid bg-white" id="review-${review.id}">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="relative w-12.5 h-12.5 bg-sky-700 rounded-full flex items-center justify-center text-xl font-bold text-white leading-normal">
              ${review.authorInitial || (review.author ? review.author[0].toUpperCase() : 'A')}

              <div class="absolute bottom-0 -right-1 w-[21px] h-[17px] flex items-center justify-center">
                <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_526_8901)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5964 5.07471L8.74606 21.3228L0.396484 10.5364L16.5964 5.07471Z" fill="white"/>
                  <path d="M8.49958 0.841797L0 4.64952V10.3615C0 15.6728 3.64518 20.6423 8.49958 21.8418C13.4015 20.633 16.9992 15.6728 16.9992 10.3615V4.64952L8.49958 0.841797ZM6.61116 16.1491L2.83347 12.3414L4.17437 10.9898L6.62949 13.4552L12.8631 7.10568L14.204 8.46732L6.61116 16.1491Z" fill="#31C2FF"/>
                </g>
                <defs>
                  <clipPath id="clip0_526_8901">
                    <rect width="17" height="21" fill="white" transform="translate(0 0.841797)"/>
                  </clipPath>
                </defs>
                </svg>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-2.5">
                <span class="text-sm md:text-base leading-normal text-gray-700 font-semibold reviewAuthor">${review.author || 'Anonymous'}</span>
                <span class="text-sm md:text-base leading-5.5 font-normal text-gray-500">${window.customTranslations.verfiedBuyer}</span>
              </div>
              <div class="flex items-end gap-1.5 reviewFlag">
                <img src="${getCountryFlag(review.countryIso, review.location)}" class="w-6 h-4" alt="${review.location || ''}" loading="lazy" />
                <span class="text-sm text-gray-500 font-normal leading-4">${review.location || 'United States'}</span>
              </div>
            </div>
          </div>
          <span class="text-sm text-gray-500 leading-5.5 font-normal">${review.reviewDate}</span>
        </div>
        <div>
          <div class="flex items-center gap-2">
            <span class="flex gap-0.5">${getStars(review.reviewRating)}</span>
            ${review.reviewTitle ? `<span class="text-sm font-bold leading-5.5 reviewTitle">${review.reviewTitle}</span>` : ''}
          </div>
          <p class="text-gray-500 text-sm leading-5.5 font-normal mt-2 reviewMessage">${review.reviewMessage}</p>
          <p class="text-gray-500 text-xs leading-5.5 font-normal mt-2 reviewVariant">${review.collectedFromSkuText || ''}</p>
            <div class="grid grid-cols-3 gap-2 w-fit mt-2 reviewPhoto">
                  
            </div>
        </div>
        <div class="flex items-center gap-4 text-xs text-gray-500 mt-2 justify-between">
          <div class="flex items-center gap-2">
            <button class="shareReviewBtn flex items-center gap-1" onclick="toggleShareReviewLinks(this)">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M5.71973 4.51172C5.7327 4.52777 5.74328 4.54463 5.73828 4.5498C5.48273 4.62083 5.26454 4.86475 5.05859 5.0293C4.69618 5.31896 4.4398 5.5304 4.13477 5.88574C4.08765 5.94071 4.03876 6.08203 4.02734 6.08203H1.60449V13.6006H12.0088V11.1953L13.6123 9.89453V14.5449C13.6123 14.5599 13.5188 14.7952 13.501 14.8252C13.3507 15.0788 13.0641 15.1118 12.8125 15.2061H0.835938C0.303059 15.0865 0.0446147 14.8992 0 14.332V5.35059C0.0306865 4.96164 0.176645 4.68143 0.561523 4.55859C0.60289 4.54551 0.819261 4.47975 0.837891 4.47852H5.68457L5.71973 4.51172ZM16 5.85059L10.6914 9.78809V7.18652C9.66107 7.1594 8.61823 7.23064 7.64355 7.57715C6.14741 8.10931 5.18087 9.34199 4.36426 10.6055C4.26753 10.755 4.1097 10.8871 4.09863 11.0713C4.03762 11.1349 4.04234 10.8029 4.0459 10.7686C4.23828 8.94858 5.11817 6.84153 6.55762 5.67188C7.71186 4.73399 9.20922 4.32416 10.6914 4.33594V1.8418L16 5.85059Z" fill="#6B7280"/></svg>
              <span class="text-gray-500 text-sm font-semibold">${window.customTranslations.share}</span>
            </button>
            <div class="shareReviewLinks invisible opacity-0 transition-opacity duration-300 flex gap-2 border-l border-gray-300 pl-2 ml-2 items-center">
              <a class="text-sm font-normal" href="${getFacebookShareUrl(review.id)}" target="_blank">${window.customTranslations.facebook}</a>
              <span>•</span>
              <a class="text-sm font-normal" href="${getTwitterShareUrl(review.reviewMessage, review.id)}" target="_blank">${window.customTranslations.twitter}</a>
            </div>
          </div>
          <div class="reviews-upvote-container flex items-center gap-2">
            <span class="ml-auto flex items-center gap-1 font-normal text-sm text-gray-500">${window.customTranslations.wasThisHelpful}</span>
            <svg class="cursor-pointer" onclick="handleReviewsUpVote(${review.id}, this)" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M8.35938 0.954132C8.68366 0.705298 9.4793 0.921147 9.81543 1.10745C10.8094 1.65857 10.7632 3.38324 10.4219 4.33206C10.2767 4.7356 10.018 5.08646 9.90625 5.50296H12.4023C12.9249 5.52837 13.4051 5.82825 13.7021 6.26859C14.1844 6.98324 14.0483 7.97032 13.5225 8.61624C13.7453 9.26918 13.6825 9.99069 13.2764 10.5479C13.4521 11.2188 13.2773 11.9799 12.8027 12.4707C12.9274 13.8346 12.133 14.7508 10.834 14.8223C9.67051 14.8863 8.53574 14.802 7.41504 14.4795C6.61497 14.2493 5.78788 13.8416 4.9834 13.6778C4.77224 13.6348 4.62209 13.6555 4.4375 13.5166C4.33978 13.443 4.2491 13.34 4.22266 13.2139C4.17731 11.2218 4.2164 9.22025 4.20215 7.22464C4.20474 6.96333 4.40147 6.72998 4.64062 6.668C4.87949 6.60609 4.92846 6.59376 5.12305 6.41507C5.74356 5.84491 6.26819 4.99752 6.80859 4.33499C6.95233 4.15883 7.14679 3.97411 7.27246 3.79202C7.80477 3.02098 7.64198 1.50479 8.35938 0.954132ZM2.96875 6.44144C3.21369 6.45959 3.42915 6.64656 3.48047 6.90921C3.5065 8.92114 3.50575 10.9421 3.48047 12.9541C3.4139 13.2313 3.22081 13.4009 2.95703 13.4219C2.17304 13.4846 1.31864 13.3739 0.527344 13.4209C0.227254 13.3943 0.00942052 13.1521 0 12.8233L0.000976562 7.0137C0.0182015 6.71765 0.229679 6.46457 0.505859 6.44534L2.96875 6.44144Z" fill="#6B7280"/></svg>
            <span class="reviewsCountSpan text-gray-700 upVoteCount">${review.votesUp || 0}</span>
          </div>
        </div>
      </div>
    `}).join('');

    // Show/hide section based on review count
    if(totalReviews > 0){
      reviewSectionNew.classList.remove('hidden-section', 'hidden-reviews', 'no-data');
    } else {
      reviewSectionNew.classList.remove('hidden-section');
      reviewSectionNew.classList.add('no-reviews');
    }
  }

  // Replace the fetch request with:
  renderReviewsFromMetaData();


  // --- Render Reviews ---
  fetch(apiUrl)
    .then(res => res.json())
    .then(res => {
      const reviews = (res.data && res.data.data) || [];

      // Collect up to 6 review photos
      const reviewPhotos = [];
      reviews.forEach(r => {
        if (r.reviewUserPhotos && reviewPhotos.length < 6) {
          // If reviewUserPhotos is a comma-separated string, split and push each
          const photos = r.reviewUserPhotos.split(',');
          photos.forEach(photo => {
            if (photo && reviewPhotos.length < 6) {
              reviewPhotos.push(`https://cdn.stamped.io/tr:h-800:/uploads/photos/${photo.trim()}`);
            }
          });
        }
      });

      // Render review photos in #reviewPhotos
      const reviewPhotosContainer = document.getElementById('reviewPhotos');
      if (reviewPhotosContainer) {
        // Collect up to 6 images from all reviews (flattened)
        const reviewPhotoImgs = [];
        reviews.forEach(r => {
          if (r.reviewUserPhotos) {
            r.reviewUserPhotos.split(',').forEach(photo => {
              if (photo && reviewPhotoImgs.length < 6) {
                reviewPhotoImgs.push({
                  photo: photo.trim(),
                  review: r
                });
              }
            });
          }
        });

        reviewPhotosContainer.innerHTML = reviewPhotoImgs
          .map(({ photo, review }) => {
            const reviewData = encodeURIComponent(JSON.stringify({
              id: review.id,
              author: review.author,
              reviewTitle: review.reviewTitle,
              reviewMessage: review.reviewMessage,
              reviewRating: review.reviewRating,
              reviewDate: review.reviewDate,
              productId: review.productId,
              productName: review.productName,
              productUrl: review.productUrl,
              productImageUrl: review.productImageUrl,
              reviewUserPhotos: photo,
              avatar: review.avatar || '',
              countryIso: review.countryIso,
              reviewVotesUp: review.reviewVotesUp,
              location: review.location || getFullCountryName(review.countryIso)
            }));
            return `<img src="https://cdn.stamped.io/tr:h-800:/uploads/photos/${photo}" 
              loading="lazy"
              class="w-16 h-12 max-h-12 object-cover rounded cursor-zoom-in"
              alt="Review photo"
              data-review="${reviewData}"
              onclick="openReviewPopup(this)"
            />`;
          })
          .join('');
      }

      reviews.forEach(review => {
        const reviewCard = document.getElementById(`review-${review.id}`);
        
        if(reviewCard){
          const reviewAuthor = reviewCard.querySelector('.reviewAuthor');

          if(reviewAuthor){
            if(review.author !== "Anonymous"){
              reviewAuthor.innerHTML = review?.author;
            } 
          }
          
          // Set upvote count
          const upVoteCountEl = reviewCard.querySelector('.upVoteCount');
          if(upVoteCountEl){
            upVoteCountEl.textContent = review.reviewVotesUp || 0;
          }

          // Update upvote button with correct API review ID
          const upvoteButton = reviewCard.querySelector('svg[onclick*="handleReviewsUpVote"]');
          if(upvoteButton) {
            upvoteButton.setAttribute('onclick', `handleReviewsUpVote(${review.id}, this)`);
          }

          // Update flag image from API data
          const flagImg = reviewCard.querySelector('.reviewFlag img');
          if(flagImg && review.countryIso) {
            const flagUrl = getCountryFlag(review.countryIso, review.location);
            flagImg.src = flagUrl;
            flagImg.alt = review.location || '';
          }

          // Add review photos if they exist in API
          if(review.reviewUserPhotos) {
            let photosContainer = reviewCard.querySelector('.reviewPhoto');

            const reviewTitle = reviewCard.querySelector('.reviewTitle')?.textContent || '';
            const reviewMessage = reviewCard.querySelector('.reviewMessage')?.textContent || '';
            
            if(photosContainer) {
              // Generate photos HTML with all the datasets and onclick functionality
              const photosHtml = review?.reviewUserPhotos?.split(',')
                .map(photo => {
                  const photoTrimmed = photo.trim();
                  const reviewData = encodeURIComponent(JSON.stringify({
                    id: review.id,
                    author: review.author,
                    reviewTitle: reviewTitle,
                    reviewMessage: reviewMessage,
                    reviewRating: review.reviewRating,
                    reviewDate: review.reviewDate,
                    productId: review.productId || productId,
                    productName: review.productName || productTitle,
                    productUrl: review.productUrl || productUrl,
                    productImageUrl: review.productImageUrl || productImage,
                    reviewUserPhotos: photoTrimmed,
                    avatar: review.avatar || '',
                    countryIso: review.countryIso,
                    reviewVotesUp: review.reviewVotesUp,
                    location: review.location || getFullCountryName(review.countryIso)
                  }));

                  return `
                    <img src="https://cdn.stamped.io/tr:h-800:/uploads/photos/${photoTrimmed}" 
                        alt="Review Photo" 
                        loading="lazy"
                        data-review="${reviewData}"
                        class="w-24 h-20 object-cover rounded cursor-zoom-in"
                        onclick="openReviewPopup(this)" />
                  `;
                })
                .join('');

              photosContainer.innerHTML = photosHtml;
            }
          }
        }
      });

    });


  // --- Helpers ---
  function getQuestionInitial(name) {
    return name && name.length ? name[0].toUpperCase() : 'A';
  }

  // Render questions using metaobjects without relaying on API

  // --- Render Questions from questionsMetaData ---
  function renderQuestionsFromMetaData() {
    if (!window.questionsMetaData || !window.questionsMetaData.questions.length) {
      console.log('No questions metadata available');
      return;
    }

    const questionsArr = window.questionsMetaData.questions;
    const totalQuestions = window.questionsMetaData.totalQuestions;

    // Update Questions tab count
    const questionsTabBtn = document.getElementById('questionsTabBtn');
    if (questionsTabBtn) {
      const span = questionsTabBtn.querySelector('span');
      if (span) span.textContent = `(${totalQuestions})`;
    }

    const container = document.getElementById('questionsCardsContainer');

    // Split into two arrays for column layout
    const questionsArrCol1 = [];
    const questionsArrCol2 = [];

    questionsArr.forEach((item, idx) => {
      if (idx % 2 === 0) {
        questionsArrCol1.push(item);
      } else {
        questionsArrCol2.push(item);
      }
    });

    // Responsive merge for questions
    let _questions;
    if (window.innerWidth >= 768) {
      _questions = [...questionsArrCol1, ...questionsArrCol2];
    } else {
      _questions = questionsArr;
    }

    if (!container) return;

    container.innerHTML = _questions.length
      ? _questions.map(question => {
          const author = abbreviateName(question.questionAuthor) || 'Anonymous';
          const date = question.questionDate || '';
          const hasAnswer = question.answerText && question.answerText.trim() !== '';

          return `
            <div class="border-b border-0 md:border border-gray-200 md:rounded-lg px-4 py-3 flex flex-col gap-4 mb-3 md:mb-4 break-inside-avoid bg-white">
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                  <div class="relative w-12.5 h-12.5 bg-sky-700 rounded-full flex items-center justify-center text-xl font-bold text-white leading-normal">
                    ${author[0] ? author[0].toUpperCase() : 'A'}
                  </div>
                  <span class="text-sm md:text-base leading-normal text-gray-700 font-semibold">${author}</span>
                </div>
                <span class="text-sm text-gray-500 leading-5.5 font-normal">${date}</span>
              </div>
              <div class="mb-2">
                <div class="flex items-start justify-center gap-1 flex-col">
                  <div class="flex items-center gap-2">
                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none"><circle cx="6" cy="6.8418" r="5.57143" stroke="#6B7280" stroke-width="0.857143"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4.87037C5.49792 4.87037 5.09091 5.25412 5.09091 5.72751C5.09091 6.01154 4.8467 6.2418 4.54545 6.2418C4.24421 6.2418 4 6.01154 4 5.72751C4 4.68606 4.89543 3.8418 6 3.8418C7.10457 3.8418 8 4.68606 8 5.72751C8 6.5259 7.47397 7.20719 6.73284 7.48247C6.65822 7.51019 6.60065 7.54938 6.56841 7.58346C6.55245 7.60033 6.54705 7.61071 6.54545 7.61502C6.54443 7.89823 6.30061 8.12751 6 8.12751C5.69875 8.12751 5.45455 7.89726 5.45455 7.61323C5.45455 7.02026 5.96106 6.66363 6.33298 6.52548C6.67125 6.39984 6.90909 6.08923 6.90909 5.72751C6.90909 5.25412 6.50208 4.87037 6 4.87037Z" fill="#6B7280"/><path d="M6 9.8418C6.40166 9.8418 6.72727 9.53479 6.72727 9.15608C6.72727 8.77737 6.40166 8.47037 6 8.47037C5.59834 8.47037 5.27273 8.77737 5.27273 9.15608C5.27273 9.53479 5.59834 9.8418 6 9.8418Z" fill="#6B7280"/></svg>  
                      <span class="text-sm font-semibold text-gray-600">${window.customTranslations.question}:</span>
                  </div>
                  <div class="ml-5 text-sm font-normal leading-5.5 text-gray-500">
                    ${question.questionText}
                  </div>
                </div>
                ${
                  hasAnswer
                    ? `<div class="flex items-center gap-2 mt-4">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.0918 9.48047L5.03711 8.36133L5.18652 8.18457H5.41895L7.89258 8.18066C9.24322 8.17878 9.86468 8.17895 10.1768 8.17285C10.3354 8.16975 10.3917 8.1653 10.416 8.16211C10.4321 8.15998 10.4136 8.16282 10.4932 8.14258C10.6187 8.11056 10.7387 8.05991 10.8525 7.98926L10.9648 7.91211C10.9886 7.89387 11.0312 7.85455 11.0732 7.81348L11.1777 7.70312C11.2765 7.58125 11.3619 7.42418 11.416 7.27148L11.459 7.12207C11.4995 6.93448 11.5 7.14262 11.5 4.77637C11.5 2.49294 11.498 2.61898 11.4678 2.46777C11.3713 1.99023 11.057 1.61618 10.6406 1.45215L10.6387 1.45117C10.572 1.42478 10.4501 1.39226 10.3408 1.375C10.3318 1.37437 10.3049 1.37251 10.2422 1.37109C10.1445 1.36889 9.97821 1.3675 9.68555 1.36621C9.1017 1.36364 8.02662 1.36227 6.0127 1.36133C4.83135 1.36039 3.75696 1.36012 2.97754 1.36035C2.58778 1.36047 2.27123 1.36101 2.05273 1.36133C1.94359 1.36149 1.859 1.36211 1.80176 1.3623H1.75879C1.75693 1.3626 1.75471 1.363 1.75293 1.36328C1.72674 1.36743 1.69397 1.37241 1.66016 1.37695H1.65723C1.45182 1.40358 1.28427 1.46692 1.11328 1.58203L1.1123 1.58301C0.814913 1.7828 0.608372 2.09128 0.532227 2.46777C0.501989 2.61899 0.5 2.49292 0.5 4.77637C0.5 5.77335 0.500721 6.30511 0.50293 6.60156C0.505206 6.90688 0.509706 6.93557 0.511719 6.94922V6.95117C0.542255 7.16324 0.577763 7.27768 0.648438 7.42383V7.4248C0.725696 7.5857 0.808504 7.7003 0.929688 7.81738C1.13051 8.01135 1.34677 8.12062 1.63379 8.16895H1.63477C1.63522 8.16901 1.63611 8.16975 1.6377 8.16992C1.64108 8.17029 1.64757 8.1702 1.6582 8.1709C1.68082 8.17237 1.717 8.17449 1.77637 8.17578C1.89535 8.17836 2.08786 8.17925 2.41992 8.18066H2.4209L3.19727 8.18555L3.69434 8.18848V8.68457L3.69629 9.82031V9.94824C3.81855 9.80363 3.95277 9.6451 4.0918 9.48047ZM1.98828 1.27832L1.98633 1.27734C1.98418 1.27877 1.98256 1.28088 1.98047 1.28223C1.98306 1.28083 1.98576 1.27973 1.98828 1.27832Z" stroke="#6B7280"/></svg>
                        <span class="text-sm font-semibold text-gray-600">${window.customTranslations.answerBy} Monitors.com</span>
                      </div>
                      <div class="ml-5 text-sm font-normal leading-5.5 text-gray-500 mt-1">
                        ${question.answerText}
                      </div>`
                    : ''
                }
              </div>
            </div>
          `;
        }).join('')
      : `<div class="p-6 text-gray-500 text-base">No questions yet.</div>`;

    // Show/hide section based on question count
    if (totalQuestions > 0) {
      reviewSectionNew.classList.remove('hidden-section', 'hidden-questions', 'no-data');
    }
  }

  // Replace the fetch request with:
  renderQuestionsFromMetaData();

  function abbreviateName(name) {
    const parts = name.trim().split(' ');
    if (parts.length < 2) {
      return name; // Return as-is if no last name
    }
    return `${parts[0]} ${parts[1].charAt(0)}.`;
  }
  


  // function to manage the photo upload functionality

  const addPhotosBtn = document.getElementById('addPhotosToReview');
  const photosInput = document.getElementById('reviewPhotosInput');
  const photosPreview = document.getElementById('reviewPhotosPreview');

  addPhotosBtn.addEventListener('click', () => {
    photosInput.click();
  });

  photosInput.addEventListener('change', function () {
    const newFiles = Array.from(this.files).filter(file =>
      !selectedPhotos.some(f => f.name === file.name && f.size === file.size)
    );
    selectedPhotos.push(...newFiles);
    renderPhotosPreview(newFiles); // Only render new files
    this.value = '';
  });

  let selectedPhotos = [];

  function renderPhotosPreview(newFiles = []) {
    const photosPreview = document.getElementById('reviewPhotosPreview');
    newFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const photoDiv = document.createElement('div');
        photoDiv.className = 'relative w-16 h-auto flex items-center';
        photoDiv.innerHTML = `
          <img src="${e.target.result}" class="w-16 h-12 object-cover rounded review-photo-img stamped-file-photo" data-index="${selectedPhotos.length - newFiles.length + index}" alt="Photo preview" loading="lazy" />
          <button type="button" class="absolute top-1 right-0.5 bg-white rounded-full h-3.5 w-3.5 flex items-center justify-center text-xs stamped-file-photo-remove1"
            onclick="removeImage(${selectedPhotos.length - newFiles.length + index})" style="line-height:1;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg>
          </button>
        `;
        photosPreview.appendChild(photoDiv);
      };
      reader.readAsDataURL(file);
    });
  }

  window.removeImage = function(index) {
    // Remove from array
    selectedPhotos.splice(index, 1);

    const photosPreview = document.getElementById('reviewPhotosPreview');
    const imageToRemove = photosPreview.querySelector(`.stamped-file-photo[data-index="${index}"]`);
    if (imageToRemove) {
      imageToRemove.parentNode.remove();
    }

    // Re-index remaining images and update remove buttons
    const remainingImages = photosPreview.querySelectorAll('.stamped-file-photo');
    remainingImages.forEach((img, newIndex) => {
      img.dataset.index = newIndex;
      const removeBtn = img.parentNode.querySelector('.stamped-file-photo-remove1');
      if (removeBtn) {
        removeBtn.setAttribute('onclick', `removeImage(${newIndex})`);
      }
    });
  };

  // function to handle submiting of add review form

  let turnstileWidgetIdReview = null;
  let isSubmittingReview = false;
  
  function handleReviewFormSubmit(e) {
    e.preventDefault();

    const form = e.target;

    const submitBtn = document.getElementById('createReviewSubmitBtn');

    // Create captcha widget on first submit
    if (turnstileWidgetIdReview === null) {
      turnstileWidgetIdReview = turnstile.render("#turnstile-widget-review", {
        sitekey: "0x4AAAAAAB7MX0ml_59yrsx8",
        theme: 'light',
        appearance: 'interaction-only',
        execution: 'execute',
        callback: function (token) {
          // This fires when verification succeeds (invisible or after user completes visible challenge)
          submitFormWithToken(form, token, submitBtn);
        },
        "error-callback": function () {
          showToast("Captcha verification failed. Please try again.", "error");
        },
        "expired-callback": function () {
          showToast("Captcha expired. Please verify again.", "error");
        }
      });
    }

    // Collect form data
    const hideMyName = document.querySelector('#hideReviewerName');
    let author = 'Anonymous';
    const email = form.querySelector('#reviewerEmail').value.trim();
    let reviewRating = form.querySelector('#reviewRating').value;
    const reviewMessage = form.querySelector('#reviewMessage').value.trim();

    if(reviewRating === '0') {
      reviewRating = '5'; // Default to 5 stars
    } 

    let fieldsToValidate = ['reviewerEmail', 'reviewMessage'];

    if(hideMyName && !hideMyName.checked) {
      author = form.querySelector('#reviewerName').value.trim();
      fieldsToValidate.unshift('reviewerName');
    }

    // Validate form fields BEFORE showing loader or rendering Turnstile
    if (!validateNotEmpty(fieldsToValidate)) {
      return;
    }

    if (isSubmittingReview) {
      return;
    }

    // Now show loader and set submitting flag
    submitBtn.classList.add('show-loader');

    turnstile.execute('#turnstile-widget-review');
    isSubmittingReview = true;

  }

  function submitFormWithToken(form, turnstileToken, submitBtn) {
    // Collect form data again (since this might be called after async verification)
    const hideMyName = document.querySelector('#hideReviewerName');
    let author = 'Anonymous';
    const email = form.querySelector('#reviewerEmail').value.trim();
    let reviewRating = form.querySelector('#reviewRating').value;
    const reviewMessage = form.querySelector('#reviewMessage').value.trim();
    const productName = productTitle;
    const productSKU = productSku;
    const productImageUrl = productImage;
    const productUrlVal = productUrl;
    const reviewTitle = '';
    const locationCountry = getFullCountryName(Shopify?.country);

    if (reviewRating === '0') {
      reviewRating = '5';
    }

    if (hideMyName && !hideMyName.checked) {
      author = form.querySelector('#reviewerName').value.trim();
    }

    // Prepare FormData
    const formData = new FormData();
    formData.append('productId', productId);
    formData.append('author', author);
    formData.append('email', email);
    formData.append('location', locationCountry);
    formData.append('reviewRating', reviewRating);
    formData.append('reviewTitle', reviewTitle);
    formData.append('reviewMessage', reviewMessage);
    formData.append('reviewRecommendProduct', 'true');
    formData.append('productName', productName);
    formData.append('productSKU', productSKU);
    formData.append('productImageUrl', productImageUrl);
    formData.append('productUrl', productUrlVal);
    formData.append('reviewSource', 'api');
    formData.append('turnstileToken', turnstileToken);

    // Append images if any
    selectedPhotos
      .filter(f => f instanceof File)
      .forEach((file, index) => {
        formData.append(`image${index + 1}`, file);
      });

    // Submit to your Cloudflare Worker
    fetch('https://submit.monitors-com.workers.dev/submit-review', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          console.log('Thank you for your review!');
          document.getElementById('reviewPhotosPreview').innerHTML = '';

          // Hide form and show thank-you message
          const formContainer = form.closest('#addReviewForm');
          const thankYouMessage = formContainer.parentElement.querySelector('.thankyou-message');
          form.classList.add('hidden');
          if (thankYouMessage) thankYouMessage.classList.remove('hidden');

        } else {
          showToast(data.error || 'Error submitting your review.', 'error');          
        }
      })
      .catch(err => {
        showToast('There was an error submitting your review.', 'error');
      })
      .finally(() => {
        submitBtn.classList.remove('show-loader');
        isSubmittingReview = false;
      });
  }

  // Attach to form
  document.querySelector('#addReviewForm form').addEventListener('submit', handleReviewFormSubmit);


  // function to manage question form submission

  let turnstileWidgetIdQuestion = null;
  let isSubmittingQuestion = false;

  function handleQuestionFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    
    const submitBtn = document.getElementById('addQuestionSubmitBtn');

    if (turnstileWidgetIdQuestion === null) {
      turnstileWidgetIdQuestion = turnstile.render("#turnstile-widget-question", {
        sitekey: "0x4AAAAAAB7MX0ml_59yrsx8",
        theme: 'light',
        appearance: 'interaction-only',
        execution: 'execute',
        callback: function (token) {
          // This fires when verification succeeds (invisible or after user completes visible challenge)
          submitQuestionFormWithToken(form, token, submitBtn);
        },
        "error-callback": function (errorCode) {
          showToast("Captcha verification failed. Please try again.", "error");
        },
        "expired-callback": function () {
          showToast("Captcha expired. Please verify again.", "error");
        }
      });
    }

    // Collect form data
    const name = form.querySelector('#questionerName').value.trim();
    const email = form.querySelector('#questionerEmail').value.trim();
    const questionBody = form.querySelector('#questionMessage').value.trim();

    let fieldsToValidate = ['questionerName', 'questionerEmail', 'questionMessage'];

    // Validate form fields BEFORE showing loader or rendering Turnstile
    if (!validateNotEmpty(fieldsToValidate)) {
      return;
    }

    
    if (isSubmittingQuestion) {
      return;
    }

    // Now show loader and set submitting flag
    submitBtn.classList.add('show-loader');

    turnstile.execute('#turnstile-widget-question');
    isSubmittingQuestion = true;

  }

  function submitQuestionFormWithToken(form, turnstileToken, submitBtn) {
    // Collect form data again (since this might be called after async verification)
    const name = form.querySelector('#questionerName').value.trim();
    const email = form.querySelector('#questionerEmail').value.trim();
    const questionBody = form.querySelector('#questionMessage').value.trim();

    // Prepare payload
    const payload = {
      productId: productId,
      name: name,
      email: email,
      questionBody: questionBody,
      productName: productTitle,
      productSKU: productSku,
      productUrl: productUrl,
      productImageUrl: normalizeImageUrl(productImage),
      turnstileToken: turnstileToken // Include the Turnstile token
    };

    fetch(createQuestionAPI, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          console.log('Thank you for your question!');
          
          // Hide form and show thank-you message
          const formContainer = form.closest('#addQuestionForm');
          const thankYouMessage = formContainer.parentElement.querySelector('.thankyou-message-question');
          form.classList.add('hidden');
          if (thankYouMessage) thankYouMessage.classList.remove('hidden');

        } else {
          showToast(data.error || 'Error submitting your question.', 'error');
        }
      })
      .catch(err => {
        showToast('There was an error submitting your question.', 'error');
      })
      .finally(() => {
        submitBtn.classList.remove('show-loader');
        isSubmittingQuestion = false;
      });
  }

  // Attach to form
  document.querySelector('#addQuestionForm form').addEventListener('submit', handleQuestionFormSubmit);

  function openReviewPopup(imgEl) {
    const reviewDataStr = imgEl.getAttribute('data-review');
    const review = JSON.parse(decodeURIComponent(reviewDataStr));
    const starsHtml = getStars(review.reviewRating);

    const popupHtml = `
      <div class="bg-white rounded shadow-xl flex flex-col md:flex-row max-w-6xl w-full relative">
        <button class="max-md:top-2 max-md:right-2 absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl" onclick="closeReviewPopup()">
          <svg focusable="false" viewBox="0 0 19 19" role="presentation" width="16" height="16">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </button>
        <div class="flex-1 flex items-center justify-center p-6">
          <img src="https://cdn.stamped.io/tr:h-800:/uploads/photos/${review.reviewUserPhotos}" alt="Review Image" class="max-h-[300px] md:max-h-[500px] max-w-full rounded object-contain" loading="lazy" />
        </div>
        <div class="flex-1 flex flex-col p-6 min-w-[320px]">
          <div class="flex items-center gap-3 mb-2">
            <div class="relative w-12.5 h-12.5 bg-sky-700 rounded-full flex items-center justify-center text-xl font-bold text-white leading-normal">
              ${review.author ? review.author[0].toUpperCase() : 'A'}
              <div class="absolute bottom-0 -right-1 w-[21px] h-[17px] flex items-center justify-center">
                <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_526_8901)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5964 5.07471L8.74606 21.3228L0.396484 10.5364L16.5964 5.07471Z" fill="white"/>
                    <path d="M8.49958 0.841797L0 4.64952V10.3615C0 15.6728 3.64518 20.6423 8.49958 21.8418C13.4015 20.633 16.9992 15.6728 16.9992 10.3615V4.64952L8.49958 0.841797ZM6.61116 16.1491L2.83347 12.3414L4.17437 10.9898L6.62949 13.4552L12.8631 7.10568L14.204 8.46732L6.61116 16.1491Z" fill="#31C2FF"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_526_8901">
                      <rect width="17" height="21" fill="white" transform="translate(0 0.841797)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-2.5">
                <span class="text-sm md:text-base leading-normal text-gray-700 font-semibold">${review.author || 'Anonymous'}</span>
                <span class="text-sm md:text-base leading-5.5 font-normal text-gray-500">${window.customTranslations.verfiedBuyer}</span>
              </div>
              <div class="flex items-end gap-1.5">
                <img src="${getCountryFlag(review.countryIso, review.location)}" class="w-6 h-4" alt="" loading="lazy" />
                <span class="text-sm text-gray-500 font-normal leading-4">${review.location || ''}</span>
              </div>
            </div>
          </div>
          <span class="text-sm text-gray-500 leading-5.5 font-normal mb-2 text-right">${review.reviewDate || ''}</span>
          <div class="flex items-center gap-2 mb-2">
            <span class="flex gap-0.5">${starsHtml}</span>
            ${review.reviewTitle ? `<span class="text-sm font-bold leading-5.5">${review.reviewTitle}</span>` : ''}
          </div>
          <p class="text-gray-500 text-sm leading-5.5 font-normal mb-2">${review.reviewMessage}</p>

          <div class="reviews-upvote-container flex items-center gap-2 mb-3 border-b border-gray-200 pb-3">
            <span class="ml-auto flex items-center gap-1 font-normal text-sm text-gray-500">${window.customTranslations.wasThisHelpful}</span>
            <svg class="cursor-pointer" onclick="handleReviewsUpVote(36803945, this)" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M8.35938 0.954132C8.68366 0.705298 9.4793 0.921147 9.81543 1.10745C10.8094 1.65857 10.7632 3.38324 10.4219 4.33206C10.2767 4.7356 10.018 5.08646 9.90625 5.50296H12.4023C12.9249 5.52837 13.4051 5.82825 13.7021 6.26859C14.1844 6.98324 14.0483 7.97032 13.5225 8.61624C13.7453 9.26918 13.6825 9.99069 13.2764 10.5479C13.4521 11.2188 13.2773 11.9799 12.8027 12.4707C12.9274 13.8346 12.133 14.7508 10.834 14.8223C9.67051 14.8863 8.53574 14.802 7.41504 14.4795C6.61497 14.2493 5.78788 13.8416 4.9834 13.6778C4.77224 13.6348 4.62209 13.6555 4.4375 13.5166C4.33978 13.443 4.2491 13.34 4.22266 13.2139C4.17731 11.2218 4.2164 9.22025 4.20215 7.22464C4.20474 6.96333 4.40147 6.72998 4.64062 6.668C4.87949 6.60609 4.92846 6.59376 5.12305 6.41507C5.74356 5.84491 6.26819 4.99752 6.80859 4.33499C6.95233 4.15883 7.14679 3.97411 7.27246 3.79202C7.80477 3.02098 7.64198 1.50479 8.35938 0.954132ZM2.96875 6.44144C3.21369 6.45959 3.42915 6.64656 3.48047 6.90921C3.5065 8.92114 3.50575 10.9421 3.48047 12.9541C3.4139 13.2313 3.22081 13.4009 2.95703 13.4219C2.17304 13.4846 1.31864 13.3739 0.527344 13.4209C0.227254 13.3943 0.00942052 13.1521 0 12.8233L0.000976562 7.0137C0.0182015 6.71765 0.229679 6.46457 0.505859 6.44534L2.96875 6.44144Z" fill="#6B7280"></path></svg>
            <span class="reviewsCountSpan text-gray-700">${review.reviewVotesUp || 0}</span>
          </div>
          <div class="flex items-center gap-2 mb-4">
            <a href="${review.productUrl}" target="_blank" class="flex items-center gap-2 no-underline">
              <img src="${review.productImageUrl}" alt="Product Image" class="w-20 h-16 object-contain rounded border" loading="lazy" />
              <div>
                <div class="text-sm font-normal text-gray-500">${review.productName || ''}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    `;

    const popup = document.getElementById('custom-review-details-popup');
    popup.innerHTML = popupHtml;
    document.body.classList.add('show-custom-review-popup');
  }


  // --- Tabs Logic ---
  const reviewsTabBtn = document.getElementById('reviewsTabBtn');
  const questionsTabBtn = document.getElementById('questionsTabBtn');
  const reviewsCardsContainer = document.getElementById('reviewsCardsContainer');
  const questionsCardsContainer = document.getElementById('questionsCardsContainer');

  if (
    reviewsTabBtn &&
    questionsTabBtn &&
    reviewsCardsContainer &&
    questionsCardsContainer
  ) {
    reviewsTabBtn.addEventListener('click', function() {
      reviewsTabBtn.classList.add('text-sky-700', 'border-sky-500');
      reviewsTabBtn.classList.remove('text-gray-500', 'md:border-gray-200','border-transparent');
      questionsTabBtn.classList.remove('text-sky-700', 'border-sky-500');
      questionsTabBtn.classList.add('text-gray-500', 'md:border-gray-200', 'border-transparent');
      reviewsCardsContainer.classList.remove('hidden');
      questionsCardsContainer.classList.add('hidden');
    });

    questionsTabBtn.addEventListener('click', function() {
      questionsTabBtn.classList.add('text-sky-700', 'border-sky-500');
      questionsTabBtn.classList.remove('text-gray-500', 'md:border-gray-200', 'border-transparent');
      reviewsTabBtn.classList.remove('text-sky-700', 'border-sky-500');
      reviewsTabBtn.classList.add('text-gray-500', 'md:border-gray-200', 'border-transparent');
      reviewsCardsContainer.classList.add('hidden');
      questionsCardsContainer.classList.remove('hidden');
    });
  }

  const addReviewForm = document.getElementById('addReviewForm');
  const addQuestionForm = document.getElementById('addQuestionForm');
  const writeReviewBtns = document.querySelectorAll('.writeReviewBtn');
  const writeQuestionBtns = document.querySelectorAll('.writeQuestionBtn');

  // Hide both forms by default
  addReviewForm.classList.remove('open');
  addQuestionForm.classList.remove('open');

  // Utility to open one form and close the other
  function toggleForm(openForm, closeForm, activeBtn, inactiveBtns) {
    if (closeForm.classList.contains('open')) {
      closeForm.classList.remove('open');
    }
    if (openForm.classList.contains('open')) {
      openForm.classList.remove('open');
      activeBtn.classList.remove('active');
    } else {
      openForm.style.maxHeight = '0px';
      void openForm.offsetWidth;
      openForm.classList.add('open');
      activeBtn.classList.add('active');
      
      // Remove active class from ALL inactive buttons
      if (inactiveBtns) {
        inactiveBtns.forEach(btn => btn.classList.remove('active'));
      }
      
      setTimeout(() => {
        openForm.style.maxHeight = '';
      }, 100);
    }
  }

  writeReviewBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const otherBtns = document.querySelectorAll('.writeQuestionBtn');
      toggleForm(addReviewForm, addQuestionForm, btn, otherBtns);
    });
  });

  writeQuestionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const otherBtns = document.querySelectorAll('.writeReviewBtn');
      toggleForm(addQuestionForm, addReviewForm, btn, otherBtns);
    });
  });


  // Script that was there in main-product.js file
  // Add that script here to avoid multiple script calls.

  function smoothScrollTo(targetPosition, duration = 800) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    // Easing function for smooth animation
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }

  /* Product custom tabs click functionality start */
  document.addEventListener('DOMContentLoaded', function() {
    const productCustomTabs = document.querySelectorAll('.product-custom-tab');
    
    productCustomTabs.forEach(function(productCustomTab) {
      productCustomTab.addEventListener('click', function(event) {
        event.preventDefault();
        let currentElementId = productCustomTab.getAttribute('id');
        let targetElementId = productCustomTab.getAttribute('data-target-id');
    
        productCustomTabs.forEach(function(element) {
          if (element.getAttribute('id') !== currentElementId) {
            if (element.classList.contains('active')) {
              element.classList.remove('active');
            }
          } else {
            if (!element.classList.contains('active')) {
              element.classList.add('active');
            }
          }
        });

        // Add condition for techspecs tab
        if (currentElementId === 'techTab') {
          const expandBtn = document.getElementById('expandBtn');
          if (expandBtn) {
            expandBtn.click();
          }
        }
    
        let fixedHeaderHeight = 146; // Adjust this selector based on fixed header element
    
        const targetElement = document.getElementById(targetElementId);
        if (targetElement) {
          let offset = targetElement.getBoundingClientRect().top + window.pageYOffset;
    
          if (fixedHeaderHeight) {
            offset -= fixedHeaderHeight;
          }
    
          // Smooth scroll to target element
          smoothScrollTo(offset, 800);
        } else {
          const nonProfitNav = document.getElementById('nonProfit_nav');
          let customTabParentSection = null;
          
          if (nonProfitNav) {
            customTabParentSection = nonProfitNav.closest('.shopify-section');
          }
    
          if (customTabParentSection && targetElementId === 'Overview') {
            let currentSection = customTabParentSection.nextElementSibling;
            
            while (currentSection) {
              if (currentSection.classList.contains('shopify-section')) {
                const customHtmlSection = currentSection.querySelector('.custom-html-section');
                const imageWithText = currentSection.querySelector('[data-section-type="image-with-text"]');
                
                if (customHtmlSection || imageWithText) {
                  let offset = currentSection.getBoundingClientRect().top + window.pageYOffset;
                  console.log(`offset : ${offset}`);
    
                  if (fixedHeaderHeight) {
                    offset -= fixedHeaderHeight;
                  }
    
                  // Smooth scroll to target element
                  smoothScrollTo(offset, 800);
                  break;
                }
              }
              currentSection = currentSection.nextElementSibling;
            }
          }
        }
      });
    });

    const atuatcBtn = document.getElementById('atuatc');
    if (atuatcBtn) {
      atuatcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const gatcBtn = document.querySelector('.gatc');
        if (gatcBtn) {
          gatcBtn.click();
        }
      });
    }
  });
  /* Product custom tabs click functionality end */

  /* On window resize change tech specs word accordingly start */
  window.addEventListener('resize', function() {
    var mobileView = window.matchMedia("(max-width: 480px)");
    var productTechSpecsWord = mobileView.matches ? 'Specs' : 'Tech Specs';
    const techSpecsWordElements = document.querySelectorAll('.tech-specs-word a');
    
    techSpecsWordElements.forEach(function(element) {
      element.textContent = productTechSpecsWord;
    });
  });
  /* On window resize change tech specs word accordingly end */

  /* On scroll adjusting product custom tabs start */
  document.addEventListener('DOMContentLoaded', function() {
    var mobileView = window.matchMedia("(max-width: 480px)");
    if (mobileView.matches) {
      const techSpecsWordElements = document.querySelectorAll('.tech-specs-word a');
      techSpecsWordElements.forEach(function(element) {
        element.textContent = 'Specs';
      });
    }

    const stickyCartWrap = document.querySelector('.sticky-cart-wrap');
    var h = stickyCartWrap ? stickyCartWrap.offsetHeight : 0;
    var summaries = document.querySelectorAll('.product_tab_wrap');

    if (window.innerWidth <= 640) {
      var productTabWrap = document.querySelector('.product_tab_wrap');
      var header = document.getElementById('headerContainer');
      var headerHeight = header ? header.offsetHeight : 0;
      var productTabWrapTop = productTabWrap ? Math.trunc(productTabWrap.getBoundingClientRect().top + window.pageYOffset) : 0;
      var isFixed = false; // variable to keep track of fixed position

      window.addEventListener('scroll', function() {
        var scrollTop = Math.trunc(window.pageYOffset || document.documentElement.scrollTop);

        function isLandscape() {
          return window.matchMedia("(orientation: landscape)").matches;
        }

        // Check if the device is in landscape mode
        if (isLandscape()) {
          // Device is in landscape mode
          if (scrollTop > productTabWrapTop) {
            if (productTabWrap) {
              productTabWrap.style.position = 'fixed';
              productTabWrap.style.top = '0px';
              productTabWrap.style.marginLeft = '0px';
              productTabWrap.style.width = '100%';
              productTabWrap.style.left = '40px';
              productTabWrap.style.marginTop = '0px';
            }
          } else {
            if (productTabWrap) {
              productTabWrap.style.position = 'relative';
              productTabWrap.style.top = 'auto';
              productTabWrap.style.marginLeft = 'auto';
              productTabWrap.style.width = 'auto';
              productTabWrap.style.marginTop = '0px';
            }
          }
          
          if (header && !header.classList.contains('header--search-expanded') && scrollTop > productTabWrapTop - headerHeight && !isFixed) {
            isFixed = true;

            if (productTabWrap) {
              productTabWrap.style.position = 'fixed';
              productTabWrap.style.top = '0px';
              productTabWrap.style.marginLeft = '0px';
              productTabWrap.style.width = '100%';
              productTabWrap.style.left = '40px';
              productTabWrap.style.marginTop = '0px';
              productTabWrap.style.zIndex = '90';
            }
          } else if (scrollTop < productTabWrapTop && isFixed) {
            isFixed = false;

            if (productTabWrap) {
              productTabWrap.style.position = 'relative';
              productTabWrap.style.top = 'auto';
              productTabWrap.style.marginLeft = 'auto';
              productTabWrap.style.width = 'auto';
              productTabWrap.style.marginTop = '0px';
            }
          }
        } else {
          // Device is in portrait mode
          var additionalHeight = 0;

          // Check if the search is expanded
          if (header && header.classList.contains('header--search-expanded')) {
            const searchBarWrapper = document.querySelector('.header__search-bar-wrapper');
            var searchBarHeight = searchBarWrapper ? searchBarWrapper.offsetHeight : 0;
            additionalHeight = searchBarHeight;
          }

          if (scrollTop > productTabWrapTop) {
            if (productTabWrap) {
              productTabWrap.style.position = 'fixed';
              productTabWrap.style.top = (headerHeight + additionalHeight) + 'px';
              productTabWrap.style.marginLeft = '0px';
              productTabWrap.style.width = '100%';
              productTabWrap.style.left = '0px';
              productTabWrap.style.zIndex = '9';
              productTabWrap.style.backgroundColor = 'color-mix(in oklab,var(--color-white)80%,transparent)';
              productTabWrap.classList.add("backdrop-blur-sm");
            }
          } else {
            if (productTabWrap) {
              productTabWrap.style.position = 'relative';
              productTabWrap.style.top = 'auto';
              productTabWrap.style.marginLeft = 'auto';
              productTabWrap.style.width = 'auto';
              productTabWrap.style.marginTop = '0px';
              productTabWrap.classList.remove("backdrop-blur-sm");
            }
          }
        }
      });
    }
    
    function checkPosition() {
      let pos = 0;
      const stickyContainer = document.querySelector('.product-form__payment-container__sticky');
      
      if (stickyContainer) {
        if (window.matchMedia('(max-width: 767px)').matches) {
          pos = stickyContainer.getBoundingClientRect().top + window.pageYOffset + 15;
        } else {
          pos = stickyContainer.getBoundingClientRect().top + window.pageYOffset - 70;
        }

        const stickySec = document.getElementById('stickySec');
        if (stickySec) {
          stickySec.classList.add('tab-static');
        }

        // Remove existing scroll listener if any to avoid duplicates
        window.removeEventListener('scroll', handleScroll);
        
        function handleScroll() {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const stickyCartWrap = document.querySelector('.sticky-cart-wrap');
          const body = document.querySelector('body.template-product');
          const stickySec = document.getElementById('stickySec');
          const goesInStickyP = document.querySelector('.goesinstickyp');
          const thisIsP = document.querySelector('.thisisp');
          const attachAgainP = document.querySelector('.attachagainp');

          if (scrollTop > pos) {
            // Add classes
            if (stickyCartWrap) stickyCartWrap.classList.add('fixed');
            if (body) {
              body.classList.add('chat-up');
              body.classList.add('sticky-add');
            }
            if (stickySec) {
              stickySec.classList.add('tab-fixed');
              stickySec.classList.remove('tab-static');
            }
            
            // Move element
            if (goesInStickyP && thisIsP) {
              thisIsP.appendChild(goesInStickyP);
            }
          } else {
            // Remove classes
            if (stickyCartWrap) stickyCartWrap.classList.remove('fixed');
            if (body) {
              body.classList.remove('chat-up');
              body.classList.remove('sticky-add');
            }
            if (stickySec) {
              stickySec.classList.remove('tab-fixed');
              stickySec.classList.add('tab-static');
            }
            
            // Move element back
            if (goesInStickyP && attachAgainP) {
              attachAgainP.appendChild(goesInStickyP);
            }
          }
        }

        // Add the scroll event listener
        window.addEventListener('scroll', handleScroll);
      }
    }

    checkPosition();
  });

  // End main-product.js script

  // scripts to lazyload image in PDP section

  // NOTE: These images used to wait for scroll (IntersectionObserver + a 500ms setTimeout) before
  // their real src was swapped in, which made description images and recommendation/recently-viewed
  // cards visibly pop in late. We now background-preload every data-src image during browser idle
  // time, so they download as soon as the page is idle -- off-viewport included -- without blocking
  // the critical render. The images keep fetchpriority="low", so the main product image, CSS, JS
  // and fonts still load first.

  function whenIdle(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 2000 });
    } else {
      setTimeout(callback, 200);
    }
  }

  // Swap a <picture class="js-lazyloaded-image"> (component.image.liquid) to its real sources.
  function loadLazyPicture(picture) {
    const img = picture.querySelector('img[data-src].not-loaded');
    if (!img || !img.dataset.src) return;

    picture.querySelectorAll('source[data-srcset]').forEach(source => {
      if (source.dataset.srcset) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      }
    });

    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.classList.remove('not-loaded');
    picture.classList.add('loaded');
  }

  // Swap a recommendation / recently-viewed product card image to its real src.
  function loadLazyProductImage(img) {
    if (!img || !img.dataset.src) return;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.classList.remove('not-loaded');
    img.classList.add('loaded');
  }

  // Find every not-yet-loaded lazy image within `root` (defaults to the whole document) and
  // schedule it to load during idle time.
  function preloadAllLazyImages(root) {
    const scope = root || document;

    scope.querySelectorAll('picture.js-lazyloaded-image').forEach(picture => {
      if (picture.querySelector('img[data-src].not-loaded')) {
        whenIdle(() => loadLazyPicture(picture));
      }
    });

    scope.querySelectorAll('img.product-card-image.not-loaded[data-src]').forEach(img => {
      whenIdle(() => loadLazyProductImage(img));
    });
  }

  // Recommendation / recently-viewed cards are injected via async fetch AFTER DOMContentLoaded, so
  // they aren't present when we first sweep the DOM. Watch for them and background-load them too.
  function watchForInjectedLazyImages() {
    if (!('MutationObserver' in window)) return;

    const mo = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue; // elements only
          if (node.matches && node.matches('img.product-card-image.not-loaded[data-src]')) {
            whenIdle(() => loadLazyProductImage(node));
          }
          if (node.querySelectorAll) {
            preloadAllLazyImages(node);
          }
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
  }

  function simpleLazyLoading() {
    document.querySelectorAll('picture.js-lazyloaded-image').forEach(picture => {
      if (picture.querySelector('img[data-src].not-loaded')) {
        whenIdle(() => loadLazyPicture(picture));
      }
    });
  }

  function productCardLazyLoading() {
    document.querySelectorAll('img.product-card-image.not-loaded[data-src]').forEach(img => {
      whenIdle(() => loadLazyProductImage(img));
    });
  }

// Initialize
document.addEventListener('DOMContentLoaded', function() {
  simpleLazyLoading();
  productCardLazyLoading();
  watchForInjectedLazyImages();

  const totalReviewsCount = window.reviewMetaData.totalReviews || 0;
  if (totalReviewsCount == 0) {
    const btn = document.querySelector('#writeQuestionBtn');
    const addQuestionForm = document.getElementById('addQuestionForm');
    btn.classList.add('active');
    addQuestionForm.classList.add('open');
  }

});